import React, { useEffect, useState } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@material-ui/core';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';

export const NavigationSelectorComponent = (props: FieldExtensionComponentProps<string[]>) => {
    const [options, setOptions] = useState<Navigation[]>([]);
    const [selectedOption, setSelectedOption] = useState('');
    const discoveryApi = useApi(discoveryApiRef);
    const { fetch } = useApi(fetchApiRef);
    const { formContext, onChange } = props;
    const { formData } = formContext;
    const aplicacao = formData.aplicacao;

    useEffect(() => {
        let cancelled = false;

        if (aplicacao) {
            (async () => {
                try {
                    const baseUrl = await discoveryApi.getBaseUrl('gmsuite-configs');
                    const response = await fetch(
                        `${baseUrl}/navigation?applicationName=${encodeURIComponent(aplicacao)}`,
                    );

                    if (!response.ok) {
                        throw new Error(`Falha ao buscar dados da API: ${response.status}`);
                    }

                    const data = await response.json();
                    if (!cancelled) {
                        setOptions(data);
                    }
                } catch (error) {
                    console.error('Erro ao buscar dados da API:', error);
                }
            })();
        }

        return () => {
            cancelled = true;
        };
    }, [aplicacao, discoveryApi, fetch]);

    const handleChange = (event: any) => {
        setSelectedOption(event.target.value);
        onChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <InputLabel htmlFor='identificador'>Selecione uma opção</InputLabel>
            <Select
                id="identificador"
                aria-describedby='helper'
                value={selectedOption}
                onChange={handleChange}
            >
                {options?.map((option) => (
                    <MenuItem key={option.identifier} value={option.identifier}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText id='helper'>
                Selecione a aplicação onde o projeto será disponibilizado
            </FormHelperText>
        </FormControl>
    );
};
